// utils/fetchWithLanguage.js
export const fetchWithLanguage = async (url, language, options = {}) => {
    const headers = {
      ...options.headers,
      language,
    };
    const response = await fetch(url, { ...options, headers });
    return response.json();
  };